import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, BriefcaseIcon, GlobeIcon, LightbulbIcon, ShieldCheckIcon, TrendingUpIcon, UsersIcon, AwardIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { Hero } from '../components/Hero';
import { StrategicRibbon } from '../components/StrategicRibbon';
export function HomePage() {
  return <div className="w-full" data-id="element-174">
      <Hero data-id="element-175" />
      <StrategicRibbon data-id="element-176" />

      {/* Trust Bar */}
      <section className="py-12 bg-white border-b border-cream-dark" data-id="element-177">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
          <p className="font-sans text-xs font-bold uppercase tracking-[0.2em] text-gray-400 text-center mb-8" data-id="element-179">
            Trusted by Organizations Operating Across West Africa
          </p>
          <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-6 opacity-40" data-id="element-180">
            <span className="font-serif text-2xl font-bold text-navy" data-id="element-181">
              USAID
            </span>
            <span className="font-serif text-2xl font-bold text-navy" data-id="element-182">
              World Bank
            </span>
            <span className="font-serif text-xl font-bold text-navy" data-id="element-183">AfDB</span>
            <span className="font-serif text-2xl font-bold text-navy" data-id="element-184">IFC</span>
            <span className="font-serif text-xl font-bold text-navy" data-id="element-185">DFID</span>
            <span className="font-serif text-xl font-bold text-navy" data-id="element-186">MCC</span>
          </div>
        </div>
      </section>

      {/* Preview Section */}
      <section className="py-20 bg-cream" data-id="element-187">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-188">
          <div className="text-center mb-16" data-id="element-189">
            <span className="inline-block font-sans font-bold text-xs uppercase tracking-widest text-gold mb-4" data-id="element-190">
              What We Do
            </span>
            <h2 className="font-serif text-4xl md:text-5xl text-navy font-bold mb-6" data-id="element-191">
              Strategic Advisory Services
            </h2>
            <div className="h-1 w-24 bg-gold mx-auto" data-id="element-192"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-193">
            <div className="bg-white rounded-card shadow-sm border border-cream-dark p-8 flex flex-col h-full group hover:shadow-md transition-shadow cursor-pointer" data-id="element-194">
              <div className="mb-6" data-id="element-195">
                <BriefcaseIcon className="h-8 w-8 text-navy" strokeWidth={1.5} data-id="element-196" />
              </div>
              <h3 className="font-serif text-xl text-navy font-semibold mb-4" data-id="element-197">
                Our Practice Areas
              </h3>
              <p className="font-sans text-text-muted leading-relaxed mb-8 flex-grow" data-id="element-198">
                Comprehensive advisory across Public Policy, Content
                Development, and Monitoring & Evaluation for African markets.
              </p>
              <Link to="/practice-areas" className="inline-flex items-center text-gold font-sans font-bold text-sm uppercase tracking-wide group-hover:text-navy transition-colors mt-auto" data-id="element-199">
                Learn More <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-200" />
              </Link>
            </div>

            <div className="bg-white rounded-card shadow-sm border border-cream-dark p-8 flex flex-col h-full group hover:shadow-md transition-shadow cursor-pointer" data-id="element-201">
              <div className="mb-6" data-id="element-202">
                <GlobeIcon className="h-8 w-8 text-navy" strokeWidth={1.5} data-id="element-203" />
              </div>
              <h3 className="font-serif text-xl text-navy font-semibold mb-4" data-id="element-204">
                Regional Focus
              </h3>
              <p className="font-sans text-text-muted leading-relaxed mb-8 flex-grow" data-id="element-205">
                Deep expertise and on-the-ground intelligence in Nigeria and
                Ghana, the most dynamic entry points for US enterprises.
              </p>
              <Link to="/regional-focus" className="inline-flex items-center text-gold font-sans font-bold text-sm uppercase tracking-wide group-hover:text-navy transition-colors mt-auto" data-id="element-206">
                Learn More <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-207" />
              </Link>
            </div>

            <div className="bg-white rounded-card shadow-sm border border-cream-dark p-8 flex flex-col h-full group hover:shadow-md transition-shadow cursor-pointer" data-id="element-208">
              <div className="mb-6" data-id="element-209">
                <LightbulbIcon className="h-8 w-8 text-navy" strokeWidth={1.5} data-id="element-210" />
              </div>
              <h3 className="font-serif text-xl text-navy font-semibold mb-4" data-id="element-211">
                Latest Insights
              </h3>
              <p className="font-sans text-text-muted leading-relaxed mb-8 flex-grow" data-id="element-212">
                Data-driven research, policy updates, and market analysis to
                inform your strategic decisions in West Africa.
              </p>
              <Link to="/insights" className="inline-flex items-center text-gold font-sans font-bold text-sm uppercase tracking-wide group-hover:text-navy transition-colors mt-auto" data-id="element-213">
                Learn More <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-214" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Impact Numbers */}
      <section className="py-20 bg-cream-dark" data-id="element-215">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-217">
            <div data-id="element-218">
              <span className="inline-block font-sans font-bold text-xs uppercase tracking-widest text-gold mb-4" data-id="element-219">
                Our Impact
              </span>
              <h2 className="font-serif text-3xl md:text-4xl text-navy font-bold mb-6 leading-tight" data-id="element-220">
                Delivering Measurable Results Across West Africa
              </h2>
              <p className="font-sans text-lg text-text-muted leading-relaxed mb-8" data-id="element-221">
                Over the past decade, Emma Kay Consulting has helped
                organizations navigate complex regulatory environments, develop
                impactful policy communications, and build robust evaluation
                frameworks that demonstrate real-world outcomes.
              </p>
              <div className="flex flex-wrap gap-4" data-id="element-222">
                <div className="flex items-center gap-2 text-navy" data-id="element-223">
                  <ShieldCheckIcon className="h-5 w-5 text-gold" data-id="element-224" />
                  <span className="font-sans text-sm font-semibold" data-id="element-225">
                    Compliance Assured
                  </span>
                </div>
                <div className="flex items-center gap-2 text-navy" data-id="element-226">
                  <TrendingUpIcon className="h-5 w-5 text-gold" data-id="element-227" />
                  <span className="font-sans text-sm font-semibold" data-id="element-228">
                    Growth Oriented
                  </span>
                </div>
                <div className="flex items-center gap-2 text-navy" data-id="element-229">
                  <AwardIcon className="h-5 w-5 text-gold" data-id="element-230" />
                  <span className="font-sans text-sm font-semibold" data-id="element-231">
                    Award-Winning Advisory
                  </span>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-6" data-id="element-232">
              <motion.div className="bg-white p-8 rounded-card shadow-sm border border-gray-100 text-center" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5
            }} data-id="element-233">
                <div className="font-serif text-4xl md:text-5xl text-navy font-bold mb-2" data-id="element-234">
                  $2.4B
                </div>
                <div className="font-sans text-sm font-semibold text-gray-500 uppercase tracking-wide" data-id="element-235">
                  Client Investments Facilitated
                </div>
              </motion.div>
              <motion.div className="bg-white p-8 rounded-card shadow-sm border border-gray-100 text-center" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} data-id="element-236">
                <div className="font-serif text-4xl md:text-5xl text-navy font-bold mb-2" data-id="element-237">
                  85+
                </div>
                <div className="font-sans text-sm font-semibold text-gray-500 uppercase tracking-wide" data-id="element-238">
                  Engagements Completed
                </div>
              </motion.div>
              <motion.div className="bg-white p-8 rounded-card shadow-sm border border-gray-100 text-center" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} data-id="element-239">
                <div className="font-serif text-4xl md:text-5xl text-navy font-bold mb-2" data-id="element-240">
                  40+
                </div>
                <div className="font-sans text-sm font-semibold text-gray-500 uppercase tracking-wide" data-id="element-241">
                  Policy Briefs Published
                </div>
              </motion.div>
              <motion.div className="bg-white p-8 rounded-card shadow-sm border border-gray-100 text-center" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} data-id="element-242">
                <div className="font-serif text-4xl md:text-5xl text-navy font-bold mb-2" data-id="element-243">
                  15+
                </div>
                <div className="font-sans text-sm font-semibold text-gray-500 uppercase tracking-wide" data-id="element-244">
                  Years of Experience
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Who We Are Teaser */}
      <section className="py-24 bg-navy text-white text-center px-4 sm:px-6 lg:px-8" data-id="element-245">
        <div className="max-w-3xl mx-auto" data-id="element-246">
          <span className="inline-block font-sans font-bold text-xs uppercase tracking-widest text-gold mb-6" data-id="element-247">
            The Firm
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-248">
            Bridging US Ambition with African Opportunity
          </h2>
          <p className="font-sans text-lg md:text-xl text-white/80 leading-relaxed mb-10" data-id="element-249">
            Emma Kay Consulting is a premier strategic advisory firm dedicated
            to helping US organizations navigate the complex public policy,
            regulatory, and cultural landscapes of Nigeria and Ghana. We
            transform market complexity into competitive advantage.
          </p>
          <Link to="/who-we-are" className="inline-block border-2 border-gold text-gold hover:bg-gold hover:text-navy font-sans font-bold text-sm uppercase tracking-wide px-8 py-4 rounded-card transition-colors" data-id="element-250">
            About Our Firm
          </Link>
        </div>
      </section>

      {/* Testimonial */}
      <section className="py-20 bg-cream" data-id="element-251">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-252">
          <div className="font-serif text-5xl text-gold/30 mb-6" data-id="element-253">"</div>
          <blockquote className="font-serif text-2xl md:text-3xl text-navy leading-relaxed mb-8 italic" data-id="element-254">
            Emma Kay Consulting provided the strategic clarity we needed to
            enter the Nigerian market with confidence. Their policy expertise
            and local networks were invaluable.
          </blockquote>
          <div className="font-sans text-sm font-semibold text-navy uppercase tracking-wider" data-id="element-255">
            — Senior VP, Global Strategy
          </div>
          <div className="font-sans text-sm text-text-muted mt-1" data-id="element-256">
            Fortune 500 Energy Company
          </div>
        </div>
      </section>
    </div>;
}